import axios from 'axios'
export default {
  name: 'Confirmacionpedido',
  components: { },
  data () {
    return {
      errores: [], cargado: false
    }
  },
  props:['usr', 'auth', 'pedido'],
  created () {
    this.enviarloginapi()
  },
  methods: {
    enviarloginapi () {
      var empresa = this.$store.getters.url_empresa
      axios.get(this.$apibase+'gen/confirmacionpedido/', {
       params: {
          "auth": this.auth, "id": this.usr, "pedido": this.pedido
        }
      })
      .then( response => this.pasologinapi(response),  response => this.errorloginapi(response) )
      .catch( response => this.errorloginapi(response))
    },
    pasologinapi: function (respuesta) {
      if (respuesta.data.estado === 1 && respuesta.data.credenciales) {
          this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales)
          if(respuesta.data.pedido){
            this.cargado = true  
          }
      } else {
        this.errorloginapi(respuesta)
      }
    },
    errorloginapi: function (respuesta) {
      console.log(respuesta)
      if (respuesta.data.estado &&  respuesta.data.estado != 1){
        this.errores = []
        this.errores.push("Error en los datos enviados")
      }
    }
  },
  computed: {
  },
  watch: {
  }
}


// WEBPACK FOOTER //
// ./src/components/js/confirmacionpedido.js